import { 
    GET_MEMBERSHIPS_FOR_BOARD, 
    GET_MEMBERSHIPS_FOR_BOARD_COUNT, 
    GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_SUCCESS,
    GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR
} from '../../Actions/EndUser/MembershipsForBoardAction';


const initialState = {
    allMemberships: [],
    membershipsForBoards: [],
    membershipsForBoardsCount: 0,
    membershipsForBoardsError: '',
}
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MEMBERSHIPS_FOR_BOARD:
            return {
                ...state,
                allMemberships: action.payload
            };
        case GET_MEMBERSHIPS_FOR_BOARD_COUNT:
            return {
                ...state,
                membershipsForBoardsCount: action.payload
            };
        case GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_SUCCESS:
            return {
                ...state,
                membershipsForBoards: action.payload
            };
        case GET_MEMBERSHIPS_FOR_BOARD_BY_PAGE_ERROR:
            return {
                ...state,
                membershipsForBoardsError: action.payload
            };
        default:
            return state;
    }
}
